import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "./components/HeroCarousel";
import StatsStrip from "./components/StatsStrip";
import SynopsisSection from "./components/SynopsisSection";
import ChapterPreview from "./components/ChapterPreview";
import FilmPicks from "./components/FilmPicks";
import SpecialTeaser from "./components/SpecialTeaser";
import HomeFaq from "./components/HomeFaq";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "色戒无删减版在线观看及剧情介绍-电影完整版平台",
    description:
      "色戒无删减版提供电影完整版资源和详细剧情介绍，涵盖高清影视内容，方便用户在线观看和信息查询。",
    keywords: "色戒无删减版,色戒电影完整版,色戒在线观看,色戒剧情介绍,色戒高清电影,色戒电影下载",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroCarousel />
        <StatsStrip />
        <SynopsisSection />
        <ChapterPreview />
        <FilmPicks />
        <SpecialTeaser />
        <HomeFaq />
      </main>
      <SiteFooter />
    </div>
  );
}